import React from 'react'
import PropTypes from 'prop-types'
import styles from './_card.css'
import Stat from './Stat'
import Comparison from './Comparison'

function Card (props) {
  const {
    activeCards,
    id,
    background,
  } = props

  const isActive = activeCards.includes(id)
  const activeClass = isActive ? styles.active : styles.inactive
  const customClass = background ? styles.custom : styles.topography
  const wrapperClass = `${styles.cardWrapper} ${activeClass} ${customClass}`

  const backgroundStyles = background ? {
    backgroundImage: `url(${background})`,
    backgroundSize: 'cover',
  } : null

  const hasValues = props.stat.number && props.comparison.value
  const card = hasValues ?
    <div id={id} className={wrapperClass}>
      <div className={styles.cardBackground} style={backgroundStyles} />
      <div className={styles.card}>
        <Stat {...props} />
        <Comparison {...props} />
      </div>
    </div> : null
  return card
}

Card.propTypes = {
  activateStatCard: PropTypes.func.isRequired,
  activeCards: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  stat: PropTypes.object,
  comparison: PropTypes.object,
  background: PropTypes.string,
  showProfileImage: PropTypes.bool,
  username: PropTypes.string,
}

export default Card



// WEBPACK FOOTER //
// ./src/components/yearInReview/2017/Card/Card.jsx